import React, { useEffect, useState } from "react";
import api, { apiErr } from "@/lib/api";
import { toast } from "sonner";
import { Mail, Save, Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function AdminSettings() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    api.get("/admin/settings").then(({ data }) => setEmail(data.notification_email || "")).catch(() => {});
  }, []);

  const save = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.put("/admin/settings", { notification_email: email });
      toast.success("Notification email saved");
    } catch (err) { toast.error(apiErr(err)); } finally { setLoading(false); }
  };

  return (
    <div className="max-w-lg space-y-5" data-testid="admin-settings-page">
      <div>
        <h1 className="font-heading text-2xl font-bold tracking-tight text-slate-900 dark:text-white">Settings</h1>
        <p className="text-sm text-slate-500 mt-1">Configure where payout notifications are sent.</p>
      </div>

      <form onSubmit={save} className="rounded-2xl border border-slate-200 dark:border-slate-800 bg-white dark:bg-slate-900 p-5 sm:p-6 space-y-4">
        <div className="flex items-center gap-2"><Mail className="h-5 w-5 text-blue-600" /><h3 className="font-heading font-semibold text-slate-900 dark:text-white">Payout notification email</h3></div>
        <div className="space-y-2">
          <Label htmlFor="ne">Email address</Label>
          <Input id="ne" type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="finance@yourbusiness.com" className="h-11" data-testid="notification-email-input" required />
          <p className="text-xs text-slate-500">A notification is sent here each time a user raises a new payout request.</p>
        </div>
        <Button type="submit" disabled={loading} className="rounded-xl bg-blue-600 hover:bg-blue-700" data-testid="save-settings-btn">
          {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : <><Save className="h-4 w-4 mr-2" /> Save settings</>}
        </Button>
      </form>
    </div>
  );
}
